<template>
  <el-dialog
    :visible.sync="isVisible"
    :top="top"
    :width="width"
    @closed="closed"
    :show-close="false"
    :custom-class="customClass"
    :close-on-click-modal="close"
    :close-on-press-escape="close">
    <span slot="title">
      <span :class="['fb-dialog_icon', type]"><i :class="icon"/></span>
      {{title}}
    </span>
    <slot/>
    <span slot="footer" class="dialog-footer">
      <el-button class="flat"
                 :disabled="isLoading"
                 v-if="showClose"
                 @click="visible(false)">CERRAR</el-button>
      <el-button class="dark"
                 :loading="isLoading"
                 :disabled="isLoading"
                 v-if="showCancel"
                 @click="confirm(false)">CANCELAR</el-button>
      <el-button class="default"
                 :loading="isLoading"
                 v-if="showConfirm"
                 @click="confirm(true)">CONFIRMAR</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'fb-dialog',
  props: {
    title: {
      required: true,
      type: String,
    },
    icon: {
      required: true,
      type: String,
    },
    top: {
      default: '10vh',
      type: String,
    },
    width: {
      default: '50%',
      type: String,
    },
    closeOn: {
      default: true,
      type: Boolean,
    },
    mode: {
      default: '',
      type: String,
    },
    type: {
      default: '',
      type: String,
    },
    showClose: {
      default: true,
      type: Boolean,
    },
    showConfirm: {
      default: false,
      type: Boolean,
    },
    showCancel: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      customClass: '',
      isVisible: false,
      isLoading: false,
    };
  },
  mounted() {
    if (this.mode !== '') this.customClass = `fb-dialog_${this.mode}`;
    if (this.type !== '') this.customClass = `${this.customClass} fb-dialog_${this.type}`;
  },
  methods: {
    visible(visible) {
      this.isVisible = visible;
    },
    loading(loading) {
      this.isLoading = loading;
    },
    confirm(confirm) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$emit('confirm', confirm);
    },
    closed() {
      this.isLoading = false;
      this.$emit('closed');
    },
  },
  computed: {
    close() {
      return this.closeOn && !this.isLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-dialog {}
</style>
